
export default function Hero() {
  return (
    <div className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/bb404bfe8f9e79eae8355c278ebc4821.jpg"
          alt="Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-8 max-w-4xl mx-auto">
        <div className="inline-block mb-6 px-5 py-2 border border-white/30 rounded-full backdrop-blur-sm">
          <span className="text-xs text-white font-medium tracking-wider">iOS DEVELOPMENT EXPERTS</span>
        </div>
        
        <h1 className="text-7xl font-bold text-white mb-6 tracking-tight leading-tight">
          Modern Applications<br />for iOS Platform
        </h1>
        
        <p className="text-xl text-white/80 font-light max-w-2xl mx-auto leading-relaxed tracking-wide">
          Enhancing user experience and mobile device security through innovative VPN and Cleaner solutions
        </p>
      </div>
    </div>
  );
}
